/**
 * The field names whose values never reach a log line or an audit record.
 *
 * Matched as substrings of a normalized key (lowercased, `_` and `-` removed),
 * so `creditCard`, `credit_card` and `CREDIT-CARD` all hit `creditcard`. The
 * bias is deliberate: over-redaction costs a debugging session, under-redaction
 * puts an SSN in a log sink.
 *
 * The logger and the action layer's audit projection both read this list — they
 * each carried their own copy of it, in different orders.
 */
export const SENSITIVE_KEY_TOKENS = [
    "ssn",
    "dob",
    "dateofbirth",
    "password",
    "secret",
    "token",
    "authorization",
    "cookie",
    "apikey",
    "creditcard",
    "cvv",
    "cvc",
    "signature",
    "email",
    "phone",
    "address",
] as const;

/** A key with the separators and case that hide a match stripped off. */
function normalizeSensitiveKey(key: string): string {
    return key.toLowerCase().replaceAll("_", "").replaceAll("-", "");
}

/** Whether a field name names something that must be redacted. */
export function isSensitiveKey(key: string, tokens: readonly string[] = SENSITIVE_KEY_TOKENS): boolean {
    const normalized = normalizeSensitiveKey(key);
    return tokens.some((token) => normalized.includes(token));
}
